import { render, staticRenderFns } from "./Geral.vue?vue&type=template&id=376e45a4&"
import script from "./Geral.vue?vue&type=script&lang=js&"
export * from "./Geral.vue?vue&type=script&lang=js&"
import style0 from "./geral.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports